// 钉钉微应用实名认证 (saas有账号，快速绑定)
<template>
  <no-ssr>
    <div class="ding-auth-sty">
      <h1 class="font-red">账号绑定</h1>
      <div class="auth-content">
        <h3 class="titleII">
          <span class="title-icon"></span>
          当前认证企业：{{loginInfo.dingTalkCorpName}}
        </h3>
        <el-form ref="bandFormRef" :model="bandForm" :rules="rules" class="band-form-sty">
          <el-form-item prop="email">
            <el-input v-model="bandForm.email" placeholder="请输入当前企业在君子签的邮箱账号" :style="{width:inputWidth}"></el-input>
          </el-form-item>
          <el-form-item prop="code">
            <el-input placeholder="请输入验证码" v-model="bandForm.code" :style="{width:inputWidth}">
              <el-button slot="append" class="append-sty" :disabled="count > 0 ? true : false" @click.prevent="getImgCode">{{ count > 0 ? count + 'S' : '获取验证码' }}</el-button>
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button v-if="isInDingTalk" style="width:158px;" @click="$router.replace({ path: '/login/middle' })">选择其他认证方式</el-button>
            <el-button type="primary" style="width:158px;" @click="bandAuthBy">立即绑定</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 图形验证码弹窗 -->
      <el-dialog title="提示" :visible.sync="imgCodeVisi" width="30%" :close-on-click-modal="false">
        <el-input
          v-model="bandForm.code_copy"
          class="input-width"
          auto-complete="off"
          placeholder="输入图形验证码"
        >
          <template slot="append">
            <span class="img-code" @click="getImgCode">
              <img :src="'data:image/png;base64,' + imgAuth.imgPath" />
            </span>
          </template>
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="imgCodeVisi = false">取 消</el-button>
          <el-button type="primary" @click="getRegistCode">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </no-ssr>
</template>
<script>
import { email } from "@/assets/js/lib/valid-methods";
import { dingtalkApi } from '@/assets/js/http-serve/dingtalkApi';
import { isInDingTalk } from "@/assets/js/utils/ding-env";

// ⚠️ dingtalk-jsapi 只能在客户端（浏览器）中使用
let dd = null;
if (process.client) {
  dd = require('dingtalk-jsapi');
}
import moment from 'moment'

export default {
  layout: 'fullpage',
  data () {
    // 这里存放数据
    return {
      isInDingTalk,
      loginInfo: { dingTalkCorpName: '' },
      imgCodeVisi: false,
      inputWidth: '460px',
      imgAuth: '',
      count:0,
      bandForm: {
        email: '',
        code: '',
        code_copy: ''
      },
      // 签署设置
      rules: {
        email: [{ validator: email, trigger: "change" }],
        code: [{ required: true, message: '请输入验证码', trigger: 'change' }],
      },
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
    /** 立即绑定 */
    bandAuthBy () {
      this.$refs.bandFormRef.validate((valid) => {
        if (valid) {
          // 先校验邮箱是否注册
          const { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo, { code, email } = this.bandForm;
          dingtalkApi.checkRegister({ corpId, dingTalkUserId, email: this.bandForm.email }).then(res => {
            if (!res.success) return this.$message.error(res.description)
            const { exists, identityAuth } = res.data
            if (exists && identityAuth == 1) {
              // 填写的邮箱已在君子签注册并实名
              const param = {
                dingTalkUserId,
                corpId,
                code,
                email
              }
              dingtalkApi.entReplenish(param).then(res => {
                if (!res.success) {
                  if (res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
                  return this.$message.error(res.description)
                }
                if (res.data.identityAuth == 1) this.$message.success('企业认证成功！')
                // toPerson 是否跳转到个人认证页面
                this.$router.replace({ path: '/login/middle',query:{corpId} })
              })
            } else {
              // 填写的邮箱在君子签未注册或未实名
              this.turnOtherWay()
            }
          })
        }
      });
    },
    turnOtherWay () {
      const _this = this;
      _this.$confirm(
        '当前账号未注册/未实名认证，请更换账号或在君子签钉钉微应用中完成实名认证。', '提示',
        {
          distinguishCancelAndClose: true,
          dangerouslyUseHTMLString: true,
          confirmButtonText: "前往认证",
          cancelButtonText: "更换账号",
          type: "warning"
        }
      )
        .then(() => {
          // 钉钉未完成实名
          const { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo, { code, email } = this.bandForm;
          const param = {
            dingTalkUserId,
            corpId,
            code,
            email
          }
          dingtalkApi.entReplenish(param).then(res => {
            if (!res.success) {
              if (res.code === '10302') return _this.$message.error('当前账号已在君子签注册，请前往绑定')
              return this.$message.error(res.description)
            }
            _this.$router.push({
              path: "/dingtalkUse/middlePage",
              query: { ap: "/auth/authGuide", t: res.data.jzqToken }
            });
          })
        })
        .catch(() => {
          _this.bandForm = {
            email: '',
            code: '',
            code_copy: ''
          }
        });
    },
    /** 获取验证码 */
    getRegistCode () {
      const _this = this, { dingTalkUserId, dingTalkCorpId: corpId } = this.loginInfo;
      if (!_this.bandForm.email) return this.$message.warning('请输入邮箱号码')
      if (!_this.bandForm.code_copy) return this.$message.warning('请输入图形验证码')
      const param = {
        corpId,
        dingTalkUserId,
        imageCode: _this.imgAuth.imgToken + "_" + _this.bandForm.code_copy,
        targetId: _this.bandForm.email
      }
      dingtalkApi.registerCodeSend(param).then(res => {
        if (!res.success) {
          if(res.code === '10506'){
            const {num} = res.data;
            if(num) _this.countdown(num);
          }
          return _this.$message.error(res.description)
        }
        _this.$message.success('已发送至邮箱');
        _this.countdown(120);
      }).finally(() => { this.imgCodeVisi = false })
    },
    countdown (count) {
      this.count =count;
      const countInterval = setInterval(() => {
        if(this.count <= 0){clearInterval(countInterval)};
        this.count--;
      }, 1000);
    },
    /** 获取图形验证码 */
    getImgCode () {
      const _this = this;
      _this.$refs.bandFormRef.validateField(['email'], (valid) => {
        if (!valid) {
          const corpId = sessionStorage.getItem("corpId"),
            { dingTalkUserId } = _this.loginInfo;
          let param = {
            corpId,
            dingTalkUserId
          };
          dingtalkApi.getImgCode(param).then(({ data }) => {
            _this.bandForm.code_copy = ''
            _this.imgAuth = data;
            _this.imgCodeVisi = true
          });
        }
        // 验证end
      })
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {
    // dd.ready 已移至 mounted，mounted 只在客户端执行，避免 SSR 调用钉钉 API
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    if (dd) {
      dd.ready(() => {
        const session = sessionStorage;
        this.loginInfo = JSON.parse(session.getItem("dingloginInfo"));
      })
    }
  },
}
</script>

<style lang='less' scoped>
@import (less) "../../../assets/style/cssVariable.less"; // 引入公共css类
.ding-auth-sty {
  width: 75vw;
  height: 90vh;
  padding-top: 20px;
  margin: 0 auto;
  background-color: @ebq-white;
  .font-red {
    color: @ebq-red;
  }
  h1 {
    text-align: center;
    font-size: 20px;
    margin-bottom: 20px;
  }
  .auth-content {
    width: 60vw;
    margin: 0 auto;
    .append-sty {
      color: @ebq-white;
      background-color: @ebq-red;
      border-color: @ebq-red;
    }
    .band-form-sty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }
  .titleII {
    display: flex;
    align-items: center;
    font-size: 15px;
    margin: 10vh 0;
  }
  .title-icon {
    display: inline-block;
    width: 5px;
    height: 15px;
    margin-right: 10px;
    background-color: @ebq-title-icon-color;
  }
  .img-code {
    background-color: #fff;
    display: inline-block;
    margin: 0 -20px;
    width: 100px;
    line-height: 30px;
    text-align: center;
    cursor: pointer;

    img {
      vertical-align: middle;
      display: inline-block;
      height: 38px;
      width: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// pages/auth/dingTalkAuthComponents/saasBand.vue